module.exports = __webpack_public_path__ + "static/media/accs.a57a1370.png";